<template>
  <layout-simple title="Allgemeine Geschäftsbedingungen">
    <v-container class="padded">
      <v-card flat>
        <h1 id="allgemeine-geschaeftsbedingungen">Allgemeine Geschäftsbedingungen</h1>
        <span>(zuletzt aktualisiert am 19.03.2025)</span>
        <h2 id="einfuehrung">Einführung</h2>
        <p>
          Die mint software GmbH, Carl-Fischer-Str. 2, 49084 Osnabrück, E-Mail: info@mmmint.ai
          (&quot;<strong>Anbieter</strong>&quot;, &quot;<strong>wir</strong>&quot; oder &quot;<strong>uns</strong>&quot;
          genannt) hat eine Plattform mit Namen schadensmeldung.digital entwickelt („<strong>Plattform</strong>“).
        </p>
        <ol>
          <li>
            Diese Allgemeinen Nutzungsbedingungen („<strong>Bedingungen</strong>“) beschreiben deine Rechte und
            Pflichten als Nutzer unserer Plattform. Diese Bedingungen stellen eine rechtsverbindliche Vereinbarung
            zwischen dir als Nutzer und uns dar.
          </li>
          <li>
            &quot;<strong>Du</strong>&quot; oder “<strong>Nutzer</strong>” bezeichnet dich persönlich. Die Plattform
            richtet sich ausschließlich an volljährige Personen. Für die Nutzung unserer Plattform versicherst du, dass
            du mindestens 18 Jahre alt bist.
          </li>
          <li>Wenn du Fragen zur Plattform hast, kannst du uns unter info@mmmint.ai erreichen.</li>
          <li>
            Wir unterhalten weitere Bedingungen und Richtlinien, die diese Bedingungen ergänzen, wie z.B. unsere
            Datenschutzrichtlinie, die unsere Sammlung und Nutzung von persönlichen Daten beschreibt.
          </li>
        </ol>
        <p>
          Der Anbieter speichert diesen Vertragstext nach Vertragsschluss unter Beachtung des Datenschutzes. Diese
          Bedingungen sind jederzeit auf der <a href="#/privacy/">Website</a>
          in druckbarer Version abrufbar.
        </p>
        <h2 id="vertragsgegenstand-plattform">Vertragsgegenstand Plattform</h2>
        <p>
          Gegenstand dieses Vertrages ist die Nutzung der Plattform auf einer von uns betriebenen Website. Teilweise
          gelangst du über die Website eines unserer Partner auf unsere Plattform. Dann kann es sein, dass wir die
          optische Gestaltung der Plattform an das Corporate Design dieses Partners angelehnt haben; es kann
          insbesondere das Logo oder den Namenszug des Partners hinterlegt sein. Dennoch besteht der Vertrag über die
          Nutzung der Plattform zwischen dir und uns. Ausdrücklich nicht Gegenstand dieses Vertrages sind sämtliche
          Leistungen, die du mit einem unserer Partner über die Plattform vereinbarst. Wir stellen lediglich die
          Plattform für dich als Nutzer und für unsere Partner bereit.
        </p>
        <p>
          Die Plattform ermöglicht es dir ein persönliches Nutzerkonto anzulegen (Ziffer 3). Gewisse Funktionen der
          Plattform können nur als registrierter Nutzer in Anspruch genommen werden.
        </p>
        <p>
          Der Anbieter ist berechtigt, die Funktionen und Ausgestaltung der Plattform im Einzelnen jederzeit zu ändern,
          anzupassen und zu updaten, insbesondere aufgrund einer geänderten Rechtslage, technischer Entwicklungen oder
          zur Verbesserung der IT-Sicherheit.
        </p>
        <p>Die Nutzung der Plattform ist für dich kostenfrei.</p>
        <h2 id="anlegen-eines-nutzerkontos">Anlegen eines Nutzerkontos</h2>
        <p>Bei der Nutzung der Plattform besteht die Möglichkeit ein Nutzerkonto anlegen.</p>
        <p>
          Hierfür benötigen wir neben den im Rahmen der Plattformnutzung bereits gemachten Angaben zu deiner Person noch
          ein von dir frei gewähltes Passwort, welches den angegebenen Passwortanforderungen entspricht.
        </p>
        <p>
          Die von dir mitgeteilten Daten bleiben im Nutzerkonto so lange gespeichert, bis du uns mitteilst, dass die
          Löschung einzelner Informationen oder des Nutzerkontos als Ganzes gewünscht ist.
        </p>
        <p>
          Soweit sich persönliche Informationen ändern, bist du selbst für deren Aktualisierung verantwortlich. Alle
          Änderungen können online nach Anmeldung in deinem Nutzerkonto vorgenommen werden.
        </p>
        <h2 id="verfuegbarkeit">Verfügbarkeit</h2>
        <p>
          Der Anbieter bemüht sich um eine hohe durchschnittliche Verfügbarkeit der Plattform. Eine ununterbrochene
          Verfügbarkeit ist jedoch technisch nicht realisierbar. Es kann zu vorübergehenden Unterbrechungen oder
          Störungen der Plattform kommen.
        </p>
        <h2 id="haftung">Haftung</h2>
        <p>
          Der Anbieter haftet dem Kunden gegenüber bei Vorsatz und grober Fahrlässigkeit auf Schadensersatz oder Ersatz
          vergeblicher Aufwendungen.
        </p>
        <p>
          In sonstigen Fällen haftet der Anbieter - soweit in Ziffer 4.3 nicht abweichend geregelt - nur bei Verletzung
          einer Vertragspflicht, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht
          und auf deren Einhaltung der Kunde regelmäßig vertrauen darf (sog. Kardinalpflicht), und zwar beschränkt auf
          den Ersatz des vorhersehbaren und typischen Schadens. In allen übrigen Fällen ist die Haftung des Anbieters -
          vorbehaltlich der Regelung in Ziffer 4.3 - ausgeschlossen.
        </p>
        <p>
          Die Haftung des Anbieters für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit und nach
          dem Produkthaftungsgesetz bleibt von den vorstehenden Haftungsbeschränkungen und –ausschlüssen unberührt.
        </p>
        <h2 id="schlussbestimmungen">Schlussbestimmungen</h2>
        <p>
          Diese Bedingungen stellen die gesamte Vereinbarung zwischen dem Anbieter und dir in Bezug auf deinen Zugang
          zur Anbieter Plattform oder deren Nutzung dar und ersetzen alle vorherigen mündlichen oder schriftlichen
          Vereinbarungen zwischen dem Anbieter und dir.
        </p>
        <p>
          Sofern es sich bei dir um einen Kaufmann, eine juristische Person des öffentlichen Rechts oder um ein
          öffentlich-rechtliches Sondervermögen handelt, ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus
          diesen Bedingungen und aus Vertragsverhältnissen, die unter Einbeziehung dieser Bedingungen geschlossen
          wurden, der Sitz von der mint software GmbH.
        </p>
        <p>
          Es findet ausschließlich das Recht der Bundesrepublik Deutschland Anwendung unter Ausschluss des
          UN-Kaufrechts.
        </p>
        <p>
          Die Parteien sind nicht berechtigt Ansprüche oder sonstige Rechte aus diesen Bedingungen ohne Zustimmung der
          jeweils anderen Parteien zu übertragen, zu verpfänden oder in sonstiger Weise zu belasten.
        </p>
        <p>
          Sollte eine Bestimmung dieses Vertrages ganz oder teilweise nichtig, unwirksam oder undurchsetzbar sein oder
          werden, wird die Wirksamkeit und Durchsetzbarkeit aller übrigen verbleibenden Bestimmungen davon nicht
          berührt. Anstelle einer nichtigen, unwirksamen oder undurchsetzbaren Bestimmung treten, soweit vorhanden, die
          gesetzlichen Vorschriften. Soweit dies für eine Vertragspartei eine unzumutbare Härte darstellen würde, wird
          der Vertrag jedoch im Ganzen unwirksam.
        </p>
      </v-card>
    </v-container>
  </layout-simple>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { PartnerEntity } from "@/models/partnerEntity";
import { ReportModule } from "@/store/modules/report.store";
import { AppContextEnum } from "@/lib/enum/appContext.enum";
import { ConfigModule } from "@/store/modules/config";
import { PartnerModule } from "@/store/modules/partner";

@Component({
  components: { LayoutSimple }
})
export default class Terms extends Vue {
  get partner(): PartnerEntity {
    return ReportModule?.partner ?? PartnerModule.partner;
  }

  get agbUrl(): string | undefined {
    return this.partner?.settings?.agbUrl?.link;
  }

  mounted() {
    if (this.agbUrl && AppContextEnum.REPORT_PORTAL !== ConfigModule.appContext) {
      window.open(this.agbUrl, "_self");
    }
  }
}
</script>

<style scoped>
.contain {
  width: 100%;
  padding: 1em;
}
</style>
